webpackJsonp([14],{

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(571),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(23);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['views', 'allergens', 'items', 'maxItemId', 'currentItemEvent', 'actionPath', 'selectedCompanyInfo', 'copyData', 'taxCategories', 'plusOne'],
  data: function data() {
    return {
      pickedItem: null,
      err: '',
      errImage: '',
      details: false,
      editViews: false,
      editAllergens: false,
      editPrinter: false,
      isItemChild: false,
      addImage: false,
      currentItemParent: null,
      abbr: null,
      name: null,
      desc: null,
      sizes: [],
      options: [],
      styles: [],
      itemId: null,
      variants: [],
      selectedViews: [],
      selectedAllergens: [],
      catalogViews: [],
      catalogAllergens: [],
      catalogPrinters: [],
      viewsInEdit: [],
      vatRate: null,
      currentLabel: null,
      currentTarget: null,
      hasPrice: false,
      hasMultiple: false,
      isDefault: false,
      labelPrint: false,
      vatPrint: false,
      noDiscount: false,
      quantityOfIncludedOptions: 0,
      galaxyCardBalance: false,
      askDetails: false,
      language: this.$cookie.get('lang') || 'en',
      languages: JSON.parse(localStorage.languages),
      pricedItems: ['sizes', 'options', 'variants'],
      multipleItems: ['sizes', 'options', 'variants', 'styles'],
      currentEdit: [{
        names: [{
          language: this.$cookie.get('lang') || 'en',
          name: ''
        }],
        languages: JSON.parse(localStorage.languages),
        price: '',
        isDefault: false,
        maxIncludedQuantity: 0
      }],
      selectedPrinters: [],
      printerCategories: ['LABEL', 'KITCHEN1', 'KITCHEN2', 'KITCHEN3', 'KITCHEN4', 'KITCHEN5', 'BAR1', 'BAR2', 'BAR3', 'BAR4', 'BAR5', 'SALAD1', 'SALAD2', 'SALAD3', 'SALAD4', 'SALAD5'],
      colors: ["#FFFFFF", "#D3d3d3", "#84A3B1", "#66BFFE", "#459DF2", "#FFC33F", "#7CF56E", "#FBF068", "#F7E7A6", "#FFC6C2", "#C98986", "#F6E4F6", "#C490D1", "#A0D2DB", "#B8336A", "#9348FA", "#F36F68", "#79B561", "#BC8F8F", "#FFE4e1", "#E9967A", "#D2691E", "#FFDAB9", "#F3D170", "#BDB76B", "#9aCd32", "#F0FFF0", "#98FB98", "#8FBC8F", "#32Cd32", "#3CB371", "#66Cdaa", "#40E0d0", "#E0FFFF", "#b0E0E6", "#87CeFa", "#4682B4", "#708090", "#E6e6Fa", "#ba55d3", "#EE82EE", "#FF69B4", "#DB7093", "#FFF0F5", "#FFC0Cb", "#CD853F"],
      color: null,
      taxCategory: 'standard',
      inheritSelectedPrinters: [],
      allImages: [],
      images: [],
      basicImages: [],
      selectedImage: {},
      selectedImageId: '',
      labels: [],
      selectedLabel: '',
      loading: false,
      loadingPreview: false,
      previewImage: '',
      inheritSelectedAttributes: {
        sizes: [],
        styles: [],
        variants: []
      },
      courseNo: 6
    };
  },

  computed: {
    filteredImages: function filteredImages() {
      var _this = this;

      return this.allImages.filter(function (image) {
        return image.label === _this.selectedLabel;
      }).sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      });
    },
    filteredAddedImages: function filteredAddedImages() {
      return this.images.sort(function (a, b) {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
      });
    },
    vatItems: function vatItems() {
      return this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0 ? [{
        text: 'Not selected',
        value: null
      }].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.selectedCompanyInfo.vatRates.map(function (vatRateItem) {
        return {
          text: '' + vatRateItem,
          value: '' + vatRateItem
        };
      }))) : [{ value: 'null', text: 'null' }];
    },
    isVatRateNotExist: function isVatRateNotExist() {
      if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0) {
        var vat = this.vatRate.toString();
        return !this.selectedCompanyInfo.vatRates.includes(Number(vat));
      }
    }
  },
  methods: {
    arraymove: function arraymove(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    },
    moveItemUp: function moveItemUp(type, index) {
      if (index === 0) {
        return;
      }
      var indexFrom = index;
      var indexTo = index - 1;
      this.arraymove(this[type], indexFrom, indexTo);
    },
    moveItemDown: function moveItemDown(type, index) {
      if (index === this[type].length - 1) {
        return;
      }
      var indexFrom = index;
      var indexTo = index + 1;
      this.arraymove(this[type], indexFrom, indexTo);
    },
    paste: function paste() {
      if (!this.copyData && !localStorage.copyItemData) return;
      var copy = {};
      if (localStorage.copyItemData) {
        copy = JSON.parse(localStorage.copyItemData);
      } else {
        copy = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.copyData));
      }
      if (copy.abbr) {
        this.abbr = {};
        this.abbr.name = copy.abbr;
      }
      if (copy.name) {
        this.name = {};
        this.name.name = copy.name;
      }
      if (copy.desc) {
        this.desc = {};
        this.desc.name = copy.desc;
      }
      this.sizes = copy.sizes || this.sizes;
      this.options = copy.options || this.options;
      this.styles = copy.styles || this.styles;
      this.variants = copy.variants || this.variants;
      // Add only views that exists in catalog
      var viewsIDs = this.views.map(function (x) {
        return x.viewId;
      }) || [];
      this.selectedViews = copy.views.filter(function (x) {
        return viewsIDs.includes(x);
      }) || this.selectedViews.filter(function (x) {
        return viewsIDs.includes(x);
      });
      // Add only allergens that exists in catalog
      var allergensIDs = this.allergens.map(function (x) {
        return x.allergenId;
      }) || [];
      this.selectedAllergens = copy.allergens.filter(function (x) {
        return allergensIDs.includes(x);
      }) || this.selectedAllergens.filter(function (x) {
        return allergensIDs.includes(x);
      });
      this.selectedPrinters = copy.printerCategories || this.selectedPrinters;
      this.vatRate = copy.vatRate || this.vatRate;
      this.labelPrint = copy.settings.labelPrint;
      this.vatPrint = copy.vatPrint;
      this.noDiscount = copy.noDiscount;
      this.galaxyCardBalance = copy.galaxyCardBalance;
      this.askDetails = copy.settings.askDetails;
      this.currentItemParent = copy.parentItem || this.currentItemParent;
      this.color = copy.colorCode || this.color;
      this.taxCategory = copy.taxCategory || this.taxCategory;
      this.courseNo = Number(copy.courseNo) || this.courseNo;
      this.quantityOfIncludedOptions = copy.quantityOfIncludedOptions || this.quantityOfIncludedOptions;
    },
    removeDefaults: function removeDefaults(data) {
      var _this2 = this;

      data.forEach(function (obj) {
        return _this2.$set(obj, 'isDefault', false);
      });
    },
    openDetails: function openDetails(label, target) {
      var _this3 = this;

      this.currentLabel = label;
      this.currentTarget = target;
      this.hasPrice = this.pricedItems.includes(target);
      this.hasMultiple = this.multipleItems.includes(target);
      this.currentEdit[0].languages = this.currentEdit[0].languages.filter(function (x) {
        return x.value !== _this3.currentEdit[0].names[0].language;
      });
      this.details = true;
    },
    openAddImage: function openAddImage() {
      this.addImage = true;
      this.fetchImagesForCompany();
    },
    deleteImg: function deleteImg(index) {
      this.images.splice(index, 1);
    },
    submitAddImage: function submitAddImage() {
      var _this4 = this;

      this.errImage = '';
      if (this.images.filter(function (image) {
        return image.id === _this4.selectedImage.id;
      }).length > 0) {
        this.errImage = 'This image is already added.';
        return;
      }
      this.images.push(this.selectedImage);
      this.selectedImage = {};
      this.selectedLabel = '';
      this.selectedImageId = '';
      this.addImage = false;
    },
    addEditLang: function addEditLang(lang, langIndex, index) {
      var editIndex = this.hasMultiple ? index : 0;
      this.currentEdit[editIndex].names.push({
        language: lang,
        name: ''
      });
      this.currentEdit[editIndex].languages.splice(langIndex, 1);
    },
    removeEdit: function removeEdit(index) {
      this.currentEdit.splice(index, 1);
    },
    removeLang: function removeLang(index, langIndex) {
      var name = this.currentEdit[index].names[langIndex].language;
      this.currentEdit[index].names.splice(langIndex, 1);
      this.currentEdit[index].languages.push(this.languages.filter(function (x) {
        return x.value === name;
      })[0]);
    },
    setEditToDefault: function setEditToDefault(index, item) {
      this.currentEdit.forEach(function (item) {
        item.isDefault = false;
      });
      this.currentEdit[index]['isDefault'] = true;
    },
    addEdit: function addEdit() {
      this.currentEdit.push({
        names: [{
          language: this.$cookie.get('lang') || 'en',
          name: ''
        }],
        languages: JSON.parse(localStorage.languages),
        price: '',
        isDefault: false
      });
    },
    editPrinterToggle: function editPrinterToggle() {
      var _this5 = this;

      this.catalogPrinters = this.catalogPrinters.map(function (current) {
        var found = false;
        _this5.selectedPrinters.forEach(function (printer) {
          if (current.name === printer) {
            found = true;
          }
        });
        var printer = current;
        printer.selected = found;
        return printer;
      });
      this.editPrinter = true;
    },
    editViewsToggle: function editViewsToggle() {
      var _this6 = this;

      this.catalogViews = this.catalogViews.map(function (current, index) {
        var found = false;
        //Views by index
        // this.selectedViews.forEach((i) => {
        //   if (index === i) {
        //     found = true;
        //   }
        // });
        //Views by Ids
        _this6.selectedViews.forEach(function (i) {
          if (current.viewId === i) {
            found = true;
          }
        });
        var view = current;
        view.selected = found;
        return view;
      });
      this.editViews = true;
    },
    editAllergensToggle: function editAllergensToggle() {
      var _this7 = this;

      this.catalogAllergens = this.catalogAllergens.map(function (current, index) {
        var found = false;
        _this7.selectedAllergens.forEach(function (i) {
          if (current.allergenId === i) {
            found = true;
          }
        });
        var allergen = current;
        allergen.selected = found;
        return allergen;
      });
      this.editAllergens = true;
    },
    closePrinter: function closePrinter() {
      this.catalogPrinters = this.catalogPrinters.map(function (current) {
        var printer = current;
        printer.selected = false;
        return printer;
      });
      this.editPrinter = false;
    },
    closeViews: function closeViews() {
      this.catalogViews = this.catalogViews.map(function (current) {
        var view = current;
        view.selected = false;
        return view;
      });
      this.editViews = false;
    },
    closeAllergens: function closeAllergens() {
      this.catalogAllergens = this.catalogAllergens.map(function (current) {
        var allergen = current;
        allergen.selected = false;
        return allergen;
      });
      this.editAllergens = false;
    },
    closeEdit: function closeEdit() {
      this.err = '';
      this.currentEdit = [{
        names: [{
          language: this.$cookie.get('lang') || 'en',
          name: ''
        }],
        languages: JSON.parse(localStorage.languages),
        price: '',
        isDefault: false
      }];
      this.details = false;
    },
    submitAllergens: function submitAllergens() {
      var allergens = [];
      this.catalogAllergens.forEach(function (allergen, index) {
        if (allergen.selected) {
          allergens.push(allergen.allergenId);
        }
      });
      this.selectedAllergens = allergens;
      this.editAllergens = false;
    },
    submitViews: function submitViews() {
      var views = [];
      this.catalogViews.forEach(function (view, index) {
        //Views by indexes
        // if (view.selected) {
        //   views.push(index);
        // }
        //Views by Ids
        if (view.selected) {
          views.push(view.viewId);
        }
      });
      this.selectedViews = views;
      this.editViews = false;
    },
    submitPrinters: function submitPrinters() {
      var printers = [];
      this.catalogPrinters.forEach(function (printer) {
        if (printer.selected) {
          printers.push(printer.name);
        }
      });
      this.selectedPrinters = printers;
      this.editPrinter = false;
      this.getAllParentPrinters();
    },
    editItem: function editItem(label, target) {
      var _this8 = this;

      this.currentLabel = label;
      this.currentTarget = target;
      this.hasPrice = this.pricedItems.includes(target);
      this.hasMultiple = this.multipleItems.includes(target);
      if (this.hasMultiple) {
        var edits = [];
        this[target].forEach(function (entry) {
          var langs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(entry.name);
          var foundLangs = [];
          var names = [];
          var edit = {};
          langs.forEach(function (lang) {
            var name = {
              language: lang,
              name: entry.name[lang]
            };
            names.push(name);
            _this8.languages.forEach(function (available, index) {
              if (available.value === lang) {
                foundLangs.push(index);
              }
            });
          });
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(edit, { names: names });
          var editLangs = _this8.languages.filter(function (lang, index) {
            var found = false;
            foundLangs.forEach(function (i) {
              if (index === i) {
                found = true;
              }
            });
            if (!found) {
              return lang;
            }
            return false;
          });
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(edit, { languages: editLangs });
          if (_this8.hasPrice) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(edit, { price: entry.price });
          }
          if (entry.isDefault) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(edit, { isDefault: entry.isDefault });
          } else {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(edit, { isDefault: false });
          }
          if (label === 'Options') {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(edit, { maxIncludedQuantity: Number(entry.maxIncludedQuantity) || 0 });
          }
          edits.push(edit);
        });
        this.currentEdit = edits;
      } else {
        var entry = this[target];
        var langs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(entry.name);
        var foundLangs = [];
        var names = [];
        var edit = {};
        langs.forEach(function (lang) {
          var name = {
            language: lang,
            name: entry.name[lang]
          };
          names.push(name);
          _this8.languages.forEach(function (available, index) {
            if (available.value === lang) {
              foundLangs.push(index);
            }
          });
        });
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(edit, { names: names });
        var editLangs = this.languages.filter(function (lang, index) {
          var found = false;
          foundLangs.forEach(function (i) {
            if (index === i) {
              found = true;
            }
          });
          if (!found) {
            return lang;
          }
          return false;
        });
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(edit, { languages: editLangs });
        if (this.hasPrice) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(edit, { price: entry.price });
        }
        if (label === 'Options') {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(edit, { maxIncludedQuantity: Number(entry.maxIncludedQuantity) });
        }
        this.currentEdit = [edit];
      }
      this.details = true;
    },
    submitEdit: function submitEdit() {
      var _this9 = this;

      var target = this.currentTarget;
      var result = [];
      var err = false;
      this.currentEdit.forEach(function (current) {
        var edit = {};
        edit.name = {};
        if (current.price === '' && _this9.hasPrice) {
          _this9.err = 'You must enter a price for each item.';
          err = true;
        }
        current.names.forEach(function (entry) {
          if (entry.name === '') {
            _this9.err = 'You must enter a name for each language on each item.';
            err = true;
          }
          edit.name[entry.language] = entry.name;
        });
        if (current.price || current.price === 0) {
          edit.price = current.price;
        }
        if (current.isDefault) {
          edit.isDefault = current.isDefault;
        }
        if (current.maxIncludedQuantity > _this9.quantityOfIncludedOptions) {
          _this9.err = 'Included Quantity value cannot be higher than Quantity Of Included Options.';
          err = true;
        }
        edit.maxIncludedQuantity = Number(current.maxIncludedQuantity) || 0;
        if (!err) {
          result.push(edit);
        }
      });
      if (err) return;
      this[target] = result;
      this[target] = this.hasMultiple ? result : result[0];
      this.closeEdit();
      this.$forceUpdate();
    },
    submitItem: function submitItem() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.err = '';

      var item = {};
      item['itemId'] = this.maxItemId + 1;
      if (this.name === null || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.name.name).length === 0) {
        if (!type) {
          this.err = 'You must enter a name for the item.';
          return;
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { name: this.name.name });
      }

      if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0) {
        if (this.vatRate === null || isNaN(this.vatRate) || this.vatRate === "") {
          if (this.isItemChild) {
            // let vatRate = this.currentItemParent.vatRate;
            // Object.assign(item, { vatRate: vatRate });
          } else {
            if (!type) {
              this.err = 'You must enter a VAT rate.';
              return;
            }
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { vatRate: this.vatRate });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { vatRate: null });
      }

      if (this.sizes.length === 0 || this.sizes[0].name === null || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.sizes[0].name).length === 0) {
        if (this.isItemChild) {
          // let sizes = this.currentItemParent.sizes;
          // Object.assign(item, {sizes: sizes});
        } else {
          if (!type) {
            // this.err = 'You must enter at least one size.';
            // return;
          }
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { sizes: this.sizes });
      }
      if (this.styles.length === 0 || this.styles[0].name === null || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.styles[0].name).length === 0) {
        if (this.isItemChild) {
          // let styles = this.currentItemParent.styles;
          // Object.assign(item, {styles: styles});
        } else {
          if (!type) {
            // this.err = 'You must enter at least one style.';
            // return;
          }
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { styles: this.styles });
      }
      if (this.options.length !== 0 && this.options[0].name !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.options[0].name).length !== 0) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { options: this.options });
      }
      if (this.options.length !== 0 && this.options[0].name !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.options[0].name).length !== 0) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { options: this.options });
      }
      if (this.variants.length !== 0 && this.variants[0].name !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.variants[0].name).length !== 0) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { variants: this.variants });
      } else {
        if (this.isItemChild) {
          if (this.currentItemParent.variants && this.currentItemParent.variants.length > 0) {
            // let variants = this.currentItemParent.variants;
            // Object.assign(item, {variants: variants});
          } else {
            if (!type) {
              // this.err = 'You must enter at least one variant.';
              // return;
            }
          }
        } else {
          if (this.pickedItem && !this.pickedItem.items) {
            if (!type) {
              // this.err = 'You must enter at least one variant.';
              // return;
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { variants: this.variants });
          }
        }
      }
      if (this.abbr !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.abbr.name).length !== 0) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { abbr: this.abbr.name });
      }
      if (this.desc !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.desc.name).length !== 0) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { desc: this.desc.name });
      }
      if (!this.selectedViews || this.selectedViews === null || this.selectedViews.length === 0) {
        this.err = 'You must enter at least one view';
        return;
      }

      var settings = {
        askDetails: this.askDetails,
        labelPrint: this.labelPrint
      };
      // !!! PART FOR EDIT !!!
      if (this.pickedItem !== null && this.currentItemEvent === 'edit') {
        var pickedItem = this.pickedItem;
        pickedItem['name'] = this.name['name'];
        pickedItem['abbr'] = this.abbr !== null ? this.abbr['name'] : null;
        pickedItem['desc'] = this.desc !== null ? this.desc['name'] : null;
        if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0) {
          pickedItem['vatRate'] = this.vatRate;
        } else {
          pickedItem['vatRate'] = null;
        }
        pickedItem['colorCode'] = this.color;
        pickedItem['courseNo'] = Number(this.courseNo);
        pickedItem['sizes'] = this.sizes || [];
        pickedItem['options'] = this.options || [];
        pickedItem['styles'] = this.styles || [];
        pickedItem['variants'] = this.variants || [];
        pickedItem['views'] = this.selectedViews || [];
        pickedItem['allergens'] = this.selectedAllergens || [];
        pickedItem['settings'] = {
          labelPrint: this.labelPrint,
          askDetails: this.askDetails
        };
        pickedItem['quantityOfIncludedOptions'] = Number(this.quantityOfIncludedOptions);
        pickedItem['vatPrint'] = this.vatPrint;
        pickedItem['noDiscount'] = this.noDiscount;
        pickedItem['galaxyCardBalance'] = this.galaxyCardBalance;
        pickedItem['taxCategory'] = this.taxCategory;
        pickedItem['images'] = this.images;

        pickedItem["printerCategories"] = this.selectedPrinters;
        if (this.currentItemParent) {
          pickedItem["parentItem"] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.currentItemParent, { items: null });
        }
        //Parent Change For This Item
        if (pickedItem.items && pickedItem.items.length > 0) {
          pickedItem['items'] = pickedItem['items'].map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
              parentItem: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, pickedItem, { items: null })
            });
          });
        }
      }
      // END FOR EDIT
      if (this.currentItemParent) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { parentItem: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.currentItemParent, { items: null }) });
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { settings: settings });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { vatPrint: this.vatPrint });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { noDiscount: this.noDiscount });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { galaxyCardBalance: this.galaxyCardBalance });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { printerCategories: this.selectedPrinters });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { views: this.selectedViews });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { allergens: this.selectedAllergens });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { selected: false });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { colorCode: this.color });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { courseNo: Number(this.courseNo) });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { taxCategory: this.taxCategory });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { images: this.images });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { quantityOfIncludedOptions: this.quantityOfIncludedOptions });
      if (type) {
        this.$emit('copy', item);
      } else {
        this.$emit('submit', item);
        this.$emit('close');
      }
    },
    addChildrenItem: function addChildrenItem() {
      if (this.currentItemEvent === 'add' && this.actionPath) {
        var depth = this.actionPath.length;
        this.isItemChild = true;
      }
    },
    getItemParent: function getItemParent() {
      if (this.items.length > 0 && this.currentItemEvent === 'add' && this.actionPath) {
        var depth = this.actionPath.length;
        var parentItem = this.items;
        if (depth === 1) {
          this.actionPath.map(function (index, i) {
            parentItem = parentItem[index];
          });
        } else if (depth > 1) {
          var actionPath = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.actionPath));
          actionPath.reverse();
          actionPath.map(function (index, i) {
            if (i + 1 !== depth) parentItem = parentItem[index].items;else {
              parentItem = parentItem[index];
            }
          });
        }
        this.currentItemParent = parentItem;
        this.inheritFromParentItem(parentItem);
      } else if (this.items.length > 0 && this.currentItemEvent === 'edit' && this.actionPath) {
        var _depth = this.actionPath.length;
        var _parentItem = this.items;
        if (_depth === 1) {
          _parentItem = null;
        } else if (_depth > 1) {
          var _actionPath = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.actionPath));
          _actionPath.reverse().pop();
          _actionPath.map(function (index, i) {
            if (i + 2 !== _depth) _parentItem = _parentItem[index].items;else {
              _parentItem = _parentItem[index];
            }
          });
        }
        this.currentItemParent = _parentItem;
      }
      if (this.plusOne) {
        this.plusOneFunct();
      }
    },
    plusOneFunct: function plusOneFunct() {
      if (this.currentItemParent.abbr && (this.currentItemParent.abbr['en'] || this.currentItemParent.abbr['de'])) {
        this.abbr = {
          name: this.currentItemParent.abbr
        };
      }
      if (this.currentItemParent.desc && (this.currentItemParent.desc['en'] || this.currentItemParent.desc['de'])) {
        this.desc = {
          name: this.currentItemParent.desc
        };
      }
      if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0 && (this.currentItemParent.vatRate || this.currentItemParent.vatRate === 0)) {
        this.vatRate = this.currentItemParent.vatRate.toString();
        if (this.isVatRateNotExist) {
          this.vatRate = null;
        }
      }
      this.sizes = this.currentItemParent.sizes || [];
      this.options = this.currentItemParent.options || [];
      this.styles = this.currentItemParent.styles || [];
      this.variants = this.currentItemParent.variants || [];
      this.selectedViews = this.currentItemParent.views || [];
      this.selectedAllergens = this.currentItemParent.allergens || [];
      this.color = this.currentItemParent.colorCode;
      this.courseNo = Number(this.currentItemParent.courseNo) || 6;
      this.taxCategory = this.currentItemParent.taxCategory || 'standard';
      if (this.currentItemParent.settings !== undefined) {
        this.askDetails = this.currentItemParent.settings.askDetails || false;
        this.labelPrint = this.currentItemParent.settings.labelPrint || false;
      }
      this.quantityOfIncludedOptions = this.currentItemParent.quantityOfIncludedOptions || 0;
      this.vatPrint = this.currentItemParent.vatPrint || false;
      this.noDiscount = this.currentItemParent.noDiscount || false;
      this.galaxyCardBalance = this.currentItemParent.galaxyCardBalance || false;
      this.basicImages = this.currentItemParent.images || [];
      this.fetchAllImages(this.basicImages);
      this.selectedPrinters = this.currentItemParent.printerCategories ? this.currentItemParent.printerCategories : [];
    },
    inheritFromParentItem: function inheritFromParentItem(parentItem) {
      if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0 && (parentItem.vatRate || parentItem.vatRate === 0) && parentItem.vatRate !== null) {
        this.vatRate = parentItem.vatRate.toString();
      } else if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length === 0) {
        this.vatRate = null;
      }
      if (parentItem.views && parentItem.views.length > 0) {
        this.selectedViews = parentItem.views;
      }
      if (parentItem.taxCategory && parentItem.taxCategory !== '') {
        this.taxCategory = parentItem.taxCategory;
      }
      if (parentItem.colorCode && parentItem.colorCode !== '') {
        this.color = parentItem.colorCode;
      }
      this.courseNo = Number(parentItem.courseNo) || 6;
      this.quantityOfIncludedOptions = parentItem.quantityOfIncludedOptions || 0;
      this.galaxyCardBalance = !!parentItem.galaxyCardBalance;
      this.noDiscount = !!parentItem.noDiscount;
      this.vatPrint = !!parentItem.vatPrint;
      if (parentItem.settings !== undefined) {
        this.askDetails = !!parentItem.settings.askDetails;
        this.labelPrint = !!parentItem.settings.labelPrint;
      }
    },
    getAllParentPrinters: function getAllParentPrinters() {
      if (this.actionPath && this.actionPath.length > 1) {
        var depth = this.actionPath.length;
        var tempActionPath = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.actionPath)).reverse();
        var tempItems = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.items));
        for (var i = 0; i < depth; i += 1) {
          if (tempItems[tempActionPath[i]].printerCategories) {
            this.inheritSelectedPrinters = this.inheritSelectedPrinters.concat(tempItems[tempActionPath[i]].printerCategories);
          }
          tempItems = tempItems[tempActionPath[i]].items;
        }
        this.inheritSelectedPrinters = this.inheritSelectedPrinters.filter(this.onlyUnique);
        this.cleanExistingPrinters();
      }
    },
    getAllParentAttributes: function getAllParentAttributes(type) {
      var _this10 = this;

      if (this.actionPath && this.actionPath.length > 1) {
        var depth = this.actionPath.length;
        var tempActionPath = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.actionPath)).reverse();
        var tempItems = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.items));
        for (var i = 0; i < depth; i += 1) {
          if (tempItems[tempActionPath[i]] && tempItems[tempActionPath[i]][type] && tempItems[tempActionPath[i]][type].length > 0 && i !== depth - 1) {
            this.inheritSelectedAttributes[type] = this.inheritSelectedAttributes[type].concat(tempItems[tempActionPath[i]][type]);
          }
          if (tempItems[tempActionPath[i]]) {
            tempItems = tempItems[tempActionPath[i]].items;
          }
        }
        this.inheritSelectedAttributes[type] = this.inheritSelectedAttributes[type].filter(function (att, index) {
          var _att = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(att);
          return index === _this10.inheritSelectedAttributes[type].findIndex(function (obj) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(obj) === _att;
          });
        });
        this.cleanExistingAttributes();
      }
    },
    renderEditableItem: function renderEditableItem() {
      // !!! PART FOR EDIT !!!
      if (this.items.length > 0 && this.currentItemEvent === 'edit' && this.actionPath) {
        var depth = this.actionPath.length;
        var currentItem = this.items;
        if (depth === 1) {
          this.actionPath.map(function (index, i) {
            currentItem = currentItem[index];
          });
        } else if (depth > 1) {
          var actionPath = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.actionPath));
          actionPath.reverse();
          actionPath.map(function (index, i) {
            if (i + 1 !== depth) currentItem = currentItem[index].items;else {
              currentItem = currentItem[index];
            }
          });
        }
        if (currentItem.name) {
          this.name = {
            name: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, currentItem.name)
          };
        }

        if (currentItem.abbr && (currentItem.abbr['en'] || currentItem.abbr['de'])) {
          this.abbr = {
            name: currentItem.abbr
          };
        }
        if (currentItem.desc && (currentItem.desc['en'] || currentItem.desc['de'])) {
          this.desc = {
            name: currentItem.desc
          };
        }
        if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0 && (currentItem.vatRate || currentItem.vatRate === 0)) {
          this.vatRate = currentItem.vatRate.toString();
          if (this.isVatRateNotExist) {
            this.vatRate = null;
          }
        }
        // this.printerCategories = [...this.items[0]]
        this.sizes = currentItem.sizes || [];
        this.options = currentItem.options || [];
        this.styles = currentItem.styles || [];
        this.variants = currentItem.variants || [];
        this.selectedViews = currentItem.views || [];
        this.selectedAllergens = currentItem.allergens || [];
        this.color = currentItem.colorCode;
        this.courseNo = Number(currentItem.courseNo) || 6;
        this.taxCategory = currentItem.taxCategory || 'standard';
        if (currentItem.settings !== undefined) {
          this.askDetails = currentItem.settings.askDetails || false;
          this.labelPrint = currentItem.settings.labelPrint || false;
        }
        this.quantityOfIncludedOptions = currentItem.quantityOfIncludedOptions || 0;
        this.vatPrint = currentItem.vatPrint || false;
        this.noDiscount = currentItem.noDiscount || false;
        this.galaxyCardBalance = currentItem.galaxyCardBalance || false;
        this.basicImages = currentItem.images || [];
        this.fetchAllImages(this.basicImages);

        this.selectedPrinters = currentItem.printerCategories ? currentItem.printerCategories : [];
        this.pickedItem = currentItem;
      }
    },
    onlyUnique: function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    cleanExistingPrinters: function cleanExistingPrinters() {
      var _this11 = this;

      this.inheritSelectedPrinters = this.inheritSelectedPrinters.filter(function (el) {
        return !_this11.selectedPrinters.includes(el);
      });
    },
    cleanExistingAttributes: function cleanExistingAttributes() {
      var _this12 = this;

      this.inheritSelectedAttributes.sizes = this.inheritSelectedAttributes.sizes.filter(function (el) {
        return !_this12.sizes.includes(el);
      });
      this.inheritSelectedAttributes.styles = this.inheritSelectedAttributes.styles.filter(function (el) {
        return !_this12.styles.includes(el);
      });
      this.inheritSelectedAttributes.variants = this.inheritSelectedAttributes.variants.filter(function (el) {
        return !_this12.variants.includes(el);
      });
    },
    fetchImageById: function fetchImageById() {
      var _this13 = this;

      this.selectedImage = {};
      this.loadingPreview = true;
      this.$http.get('imageresource/' + this.selectedImageId).then(function (res) {
        if (res.body.status === 'Success') {
          _this13.loadingPreview = false;
          _this13.selectedImage = res.body.imageResource;
          return;
        }
        _this13.loadingPreview = false;
        _this13.err = res.body.statusText;
      }, function (err) {
        _this13.err = err.body.statusText || err.body.message;
      });
    },
    fetchLabels: function fetchLabels() {
      var _this14 = this;

      this.labels = [];
      this.$http.get('system/imageresource/fetchimageresourcelabels').then(function (res) {
        if (res.body.status === 'Success') {
          _this14.labels = res.body.imageResourceLabels.sort();
          return;
        }
        _this14.err = res.body.statusText;
      }, function (err) {
        _this14.err = err.body.statusText || err.body.message;
      });
    },
    fetchImagesForCompany: function fetchImagesForCompany() {
      var _this15 = this;

      this.loading = true;
      this.allImages = [];
      this.$http.post('imageresource', { companyId: this.selectedCompanyInfo.id }).then(function (res) {
        if (res.body.status === 'Success') {
          _this15.loading = false;
          _this15.allImages = res.body.imageResources;
          if (_this15.allImages.length === 0) {
            _this15.loading = false;
          }
          return;
        }
        _this15.err = res.body.statusText;
      }, function (err) {
        _this15.loading = false;
        _this15.err = err.body.statusText || err.body.message;
      });
    },
    fetchAllImages: function fetchAllImages(basicImages) {
      var _this16 = this;

      if (basicImages.length > 0) {
        basicImages.forEach(function (image) {
          _this16.$http.get('imageresource/' + (image.value || image.id)).then(function (res) {
            if (res.body.status === 'Success') {
              _this16.images.push(res.body.imageResource);
              return;
            }
            _this16.err = res.body.statusText;
          }, function (err) {
            _this16.err = err.body.statusText || err.body.message;
          });
        });
      }
    },
    preview: function preview(base64Image) {
      this.previewImage = base64Image;
    }
  },
  mounted: function mounted() {
    if (this.selectedCompanyInfo && this.selectedCompanyInfo.defaultLanguage) this.$cookie.set('lang', this.selectedCompanyInfo.defaultLanguage);
  },
  created: function created() {
    var _this17 = this;

    this.renderEditableItem();
    this.addChildrenItem();
    this.getItemParent();
    this.getAllParentPrinters();
    ['sizes', 'styles', 'variants'].forEach(function (att) {
      return _this17.getAllParentAttributes(att);
    });
    this.fetchLabels();
    this.catalogViews = this.views.map(function (current) {
      var view = current;
      view.selected = false;
      return view;
    });
    this.catalogAllergens = this.allergens.map(function (current) {
      var allergen = current;
      allergen.selected = false;
      return allergen;
    });
    this.catalogPrinters = this.printerCategories.map(function (current) {
      var printer = {
        name: current
      };
      printer.selected = false;
      return printer;
    });
  }
});

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".vat .v-label{font-size:20px}.checkbox-wrap{width:100%}.checkbox-wrap .input-group{min-width:140px;flex:none;width:auto;width:fit-content;padding:0 32px}.checkbox-wrap .input-group .input-group__details{display:none!important}.checkbox-wrap .input-group label{position:relative!important;left:0;max-width:220px;width:auto;width:fit-content;overflow:hidden}.checkbox-wrap .input-group .input-group__input{position:absolute;left:0;top:0;width:32px;flex:0}.checkbox-wrap .input-group \\--selection-controls{display:inline}.err{font-size:16px;padding:15px;padding-top:0}.modal{display:block;background:rgba(0,0,0,.5)}.modal-body{max-height:80vh;overflow-y:auto}tbody.multiple:not(:last-child){border-bottom:2px solid rgba(0,0,0,.3)}label.checkbox{vertical-align:middle;margin-bottom:10px;cursor:pointer}label.checkbox span{display:inline-block;position:relative;width:18px;height:18px;border-radius:4px;background-color:#fff;border:1px solid #d0d4d9;vertical-align:middle;margin-right:1px}label.checkbox span:before{content:\"\\E5CA\";position:absolute;font-family:Material Icons;font-size:24px;color:#2196f3;font-weight:700;text-align:center;width:22px;height:26px;left:-2px;bottom:0;margin:auto;transform:scale(0);transition:all .1s ease-in}label.checkbox input{display:none}label.checkbox.is-checked span:before{transform:scale(1)}.vat-rate-input{margin-top:15px}.question-block{margin-top:60px}.default-item{display:inline-block;margin-left:20px}.views p{display:inline;text-align:left;color:rgba(0,0,0,.78);cursor:pointer}.views li,.views li p{cursor:default}.views li p{margin:0;vertical-align:middle;color:#333}.views li i{vertical-align:middle;font-size:1.5rem;border-radius:4px;padding:.5rem;cursor:pointer}.light-text{color:#9e9e9e}.underline:not(:first-of-type){border-top:2px solid #d6d6d6}@media (min-width:576px){.modal-dialog{max-width:90%}}.color-preview{display:inline-block;margin-left:5px;width:14px;height:14px;border-radius:50%;border:1px solid #bdbdbd}.list-color-preview{max-height:28px;height:100%;margin:8px 0}.arrow_to_move{width:10px;position:relative;display:inline-block;margin-right:10px}.arrow_to_move i{font-size:20px;display:inline;position:absolute}.arrow_to_move i:first-child{margin-top:-25px}.arrow_to_move i:last-of-type{margin-top:-5px}.pointerClass{cursor:pointer}.pointerClass:hover{font-weight:700;color:red;cursor:pointer}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/SingleItem.vue"],"names":[],"mappings":"AACA,cACE,cAAgB,CACjB,AACD,eACE,UAAY,CACb,AACD,4BACI,gBAAiB,AACjB,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,cAAgB,CACnB,AACD,kDACM,sBAAyB,CAC9B,AACD,kCACM,4BAA8B,AAC9B,OAAQ,AACR,gBAAiB,AACjB,WAAY,AACZ,kBAAmB,AACnB,eAAiB,CACtB,AACD,gDACM,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,MAAQ,CACb,AACD,kDACM,cAAgB,CACrB,AACD,KACE,eAAgB,AAChB,aAAc,AACd,aAAe,CAChB,AACD,OACE,cAAe,AACf,yBAA+B,CAChC,AACD,YACI,gBAAiB,AACjB,eAAiB,CACpB,AACD,gCACE,sCAA4C,CAC7C,AACD,eACE,sBAAuB,AACvB,mBAAoB,AACpB,cAAgB,CACjB,AACD,oBACI,qBAAsB,AACtB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,sBAA0B,AAC1B,yBAA0B,AAC1B,sBAAuB,AACvB,gBAAkB,CACrB,AACD,2BACM,gBAAiB,AACjB,kBAAmB,AACnB,2BAA8B,AAC9B,eAAgB,AAChB,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,UAAW,AACX,SAAU,AACV,YAAa,AACb,mBAAoB,AACpB,0BAA8B,CACnC,AACD,qBACI,YAAc,CACjB,AACD,sCACI,kBAAoB,CACvB,AACD,gBACE,eAAiB,CAClB,AACD,gBACE,eAAiB,CAClB,AACD,cACE,qBAAsB,AACtB,gBAAkB,CACnB,AACD,SACE,eAAgB,AAChB,gBAAiB,AACjB,sBAA2B,AAC3B,cAAgB,CACjB,AAID,sBAFE,cAAgB,CAOjB,AALD,YACI,SAAU,AACV,sBAAuB,AACvB,UAAY,CAEf,AACD,YACI,sBAAuB,AACvB,iBAAkB,AAClB,kBAAmB,AACnB,cAAgB,AAChB,cAAgB,CACnB,AACD,YACE,aAAe,CAChB,AACD,+BACE,4BAA8B,CAC/B,AACD,yBACA,cACI,aAAe,CAClB,CACA,AACD,eACE,qBAAsB,AACtB,gBAAiB,AACjB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,wBAA0B,CAC3B,AACD,oBACE,gBAAiB,AACjB,YAAa,AACb,YAAc,CACf,AACD,eACE,WAAY,AACZ,kBAAmB,AACnB,qBAAsB,AACtB,iBAAmB,CACpB,AACD,iBACI,eAAgB,AAChB,eAAgB,AAChB,iBAAmB,CACtB,AACD,6BACM,gBAAkB,CACvB,AACD,8BACM,eAAiB,CACtB,AACD,cACE,cAAgB,CACjB,AACD,oBACE,gBAAkB,AAClB,UAAW,AACX,cAAgB,CACjB","file":"SingleItem.vue","sourcesContent":["\n.vat .v-label {\n  font-size: 20px;\n}\n.checkbox-wrap {\n  width: 100%;\n}\n.checkbox-wrap .input-group {\n    min-width: 140px;\n    flex: none;\n    width: auto;\n    width: fit-content;\n    padding: 0 32px;\n}\n.checkbox-wrap .input-group .input-group__details {\n      display: none !important;\n}\n.checkbox-wrap .input-group label {\n      position: relative !important;\n      left: 0;\n      max-width: 220px;\n      width: auto;\n      width: fit-content;\n      overflow: hidden;\n}\n.checkbox-wrap .input-group .input-group__input {\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 32px;\n      flex: 0;\n}\n.checkbox-wrap .input-group --selection-controls {\n      display: inline;\n}\n.err {\n  font-size: 16px;\n  padding: 15px;\n  padding-top: 0;\n}\n.modal {\n  display: block;\n  background: rgba(0, 0, 0, 0.5);\n}\n.modal-body {\n    max-height: 80vh;\n    overflow-y: auto;\n}\ntbody.multiple:not(:last-child) {\n  border-bottom: 2px solid rgba(0, 0, 0, 0.3);\n}\nlabel.checkbox {\n  vertical-align: middle;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\nlabel.checkbox span {\n    display: inline-block;\n    position: relative;\n    width: 18px;\n    height: 18px;\n    border-radius: 4px;\n    background-color: #ffffff;\n    border: 1px solid #d0d4d9;\n    vertical-align: middle;\n    margin-right: 1px;\n}\nlabel.checkbox span:before {\n      content: \"\\E5CA\";\n      position: absolute;\n      font-family: 'Material Icons';\n      font-size: 24px;\n      color: #2196F3;\n      font-weight: 700;\n      text-align: center;\n      width: 22px;\n      height: 26px;\n      left: -2px;\n      bottom: 0;\n      margin: auto;\n      transform: scale(0);\n      transition: all 100ms ease-in;\n}\nlabel.checkbox input {\n    display: none;\n}\nlabel.checkbox.is-checked span:before {\n    transform: scale(1);\n}\n.vat-rate-input {\n  margin-top: 15px;\n}\n.question-block {\n  margin-top: 60px;\n}\n.default-item {\n  display: inline-block;\n  margin-left: 20px;\n}\n.views p {\n  display: inline;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.78);\n  cursor: pointer;\n}\n.views li {\n  cursor: default;\n}\n.views li p {\n    margin: 0;\n    vertical-align: middle;\n    color: #333;\n    cursor: default;\n}\n.views li i {\n    vertical-align: middle;\n    font-size: 1.5rem;\n    border-radius: 4px;\n    padding: 0.5rem;\n    cursor: pointer;\n}\n.light-text {\n  color: #9e9e9e;\n}\n.underline:not(:first-of-type) {\n  border-top: 2px solid #d6d6d6;\n}\n@media (min-width: 576px) {\n.modal-dialog {\n    max-width: 90%;\n}\n}\n.color-preview {\n  display: inline-block;\n  margin-left: 5px;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 1px solid #bdbdbd;\n}\n.list-color-preview {\n  max-height: 28px;\n  height: 100%;\n  margin: 8px 0;\n}\n.arrow_to_move {\n  width: 10px;\n  position: relative;\n  display: inline-block;\n  margin-right: 10px;\n}\n.arrow_to_move i {\n    font-size: 20px;\n    display: inline;\n    position: absolute;\n}\n.arrow_to_move i:first-child {\n      margin-top: -25px;\n}\n.arrow_to_move i:last-of-type {\n      margin-top: -5px;\n}\n.pointerClass {\n  cursor: pointer;\n}\n.pointerClass:hover {\n  font-weight: bold;\n  color: red;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(518);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("45c0236f", content, true, {});

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.details && !_vm.editViews && !_vm.editPrinter && !_vm.addImage && !_vm.editAllergens) ? _c('main', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.currentItemEvent === 'edit' ? _vm.$lang.header.edit : _vm.$lang.header.add) + " " + _vm._s(_vm.$lang.header.item))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.err))]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "vat",
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0 mt-2 max-w",
    attrs: {
      "label": _vm.$lang.header.vat,
      "items": _vm.vatItems,
      "disabled": !this.selectedCompanyInfo.vatRates || this.selectedCompanyInfo.vatRates.length === 0,
      "hide-details": ""
    },
    model: {
      value: (_vm.vatRate),
      callback: function($$v) {
        _vm.vatRate = $$v
      },
      expression: "vatRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.views))]), _vm._v(" "), (_vm.selectedViews.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": _vm.editViewsToggle
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": _vm.editViewsToggle
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.selectedViews.length > 0) ? _c('div', {
    staticClass: "views mt-2 p-3"
  }, [_vm._l((_vm.views), function(view, index) {
    return (_vm.selectedViews.indexOf(view.viewId !== -1) && _vm.selectedViews[_vm.selectedViews.indexOf(view.viewId)] === view.viewId) ? [_c('p', {
      key: index
    }, [_vm._v(_vm._s(view.name[_vm.language]) + ", ")])] : _vm._e()
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.printerCategories))]), _vm._v(" "), (_vm.selectedPrinters.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editPrinterToggle()
      }
    }
  }, [_vm._v("\n                  add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editPrinterToggle()
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.selectedPrinters.length > 0 || _vm.inheritSelectedPrinters.length > 0) ? _c('div', {
    staticClass: "views mt-2 p-3"
  }, [_vm._l((_vm.selectedPrinters), function(category, index) {
    return [_c('p', {
      key: index
    }, [_vm._v(_vm._s(category) + ", ")])]
  }), _vm._v(" "), _vm._l((_vm.inheritSelectedPrinters), function(printer, index2) {
    return [_c('p', {
      key: 'I-' + index2,
      staticStyle: {
        "color": "blue !important"
      }
    }, [_vm._v(_vm._s(printer) + ", ")])]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.abbreviation))]), _vm._v(" "), (_vm.abbr === null) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Abbreviation', 'abbr')
      }
    }
  }, [_vm._v("\n                  add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Abbreviation', 'abbr')
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.abbr !== null) ? _c('ul', _vm._l((_vm.languages), function(lang, index) {
    return (_vm.abbr && _vm.abbr.name[lang.value]) ? _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "d-inline-block light-text"
    }, [_vm._v("\n                [" + _vm._s(lang.text) + "]\n              ")]), _vm._v("\n                  " + _vm._s(_vm.abbr.name[lang.value]) + "\n                ")]) : _vm._e()
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.name))]), _vm._v(" "), (_vm.name === null) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Name', 'name')
      }
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Name', 'name')
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.name !== null) ? _c('ul', {
    staticClass: "mt-2"
  }, _vm._l((_vm.languages), function(lang, index) {
    return (_vm.name && _vm.name.name[lang.value]) ? _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "d-inline-block light-text"
    }, [_vm._v("\n                [" + _vm._s(lang.text) + "]\n              ")]), _vm._v("\n                  " + _vm._s(_vm.name.name[lang.value]) + "\n                ")]) : _vm._e()
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.description))]), _vm._v(" "), (_vm.desc === null) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Description', 'desc')
      }
    }
  }, [_vm._v("\n                  add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Description', 'desc')
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.desc !== null) ? _c('ul', {
    staticClass: "mt-2"
  }, _vm._l((_vm.languages), function(lang, index) {
    return (_vm.desc && _vm.desc.name[lang.value]) ? _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "d-inline-block light-text"
    }, [_vm._v("\n                [" + _vm._s(lang.text) + "]\n              ")]), _vm._v("\n                  " + _vm._s(_vm.desc.name[lang.value]) + "\n                ")]) : _vm._e()
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.sizes))]), _vm._v(" "), (_vm.sizes.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Sizes', 'sizes')
      }
    }
  }, [_vm._v("\n                  add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Sizes', 'sizes')
      }
    }
  }, [_vm._v("edit")]), _vm._v(" "), (_vm.sizes.length > 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.removeDefaults(_vm.sizes)
      }
    }
  }, [_vm._v("\n                  turned_in_not\n                ")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.sizes), function(size, index) {
    return (_vm.sizes.length !== 0) ? [_c('ul', {
      key: index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (size.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v("\n                    " + _vm._s(size.name[lang.value]) + "\n                    " + _vm._s(size.price) + "\n                    "), (size.isDefault) ? _c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  <" + _vm._s(_vm.$lang.labels.default) + ">\n                ")]) : _vm._e(), _vm._v(" "), (_vm.sizes.length > 1) ? _c('span', {
        staticClass: "arrow_to_move"
      }, [_c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemUp('sizes', index)
          }
        }
      }, [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemDown('sizes', index)
          }
        }
      }, [_vm._v("keyboard_arrow_down")])]) : _vm._e()]) : _vm._e()
    }), 0)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.inheritSelectedAttributes.sizes), function(size, index) {
    return (_vm.inheritSelectedAttributes.sizes !== 0) ? [_c('ul', {
      key: 'inhSize-' + index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (size.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "color": "blue !important"
        }
      }, [_vm._v(_vm._s(size.name[lang.value]) + "\n                      " + _vm._s(size.price))])]) : _vm._e()
    }), 0)] : _vm._e()
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.options))]), _vm._v(" "), (_vm.options.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Options', 'options')
      }
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Options', 'options')
      }
    }
  }, [_vm._v("edit")]), _vm._v(" "), (_vm.options.length > 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.removeDefaults(_vm.options)
      }
    }
  }, [_vm._v("\n                  turned_in_not\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "d-inline-flex",
    staticStyle: {
      "max-height": "25px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.quantityOfIncludedOptions) + ":")]), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "max-width": "100px"
    },
    attrs: {
      "type": "number",
      "solo": "",
      "flat": "",
      "min": "0"
    },
    model: {
      value: (_vm.quantityOfIncludedOptions),
      callback: function($$v) {
        _vm.quantityOfIncludedOptions = $$v
      },
      expression: "quantityOfIncludedOptions"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.options), function(option, index) {
    return (_vm.options.length !== 0) ? [_c('ul', {
      key: index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (option.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v("\n                    " + _vm._s(option.name[lang.value]) + "\n                    " + _vm._s(option.price) + "\n                    "), _c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                      (max: " + _vm._s(option.maxIncludedQuantity) + ")\n                    ")]), _vm._v(" "), (option.isDefault) ? _c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                      <" + _vm._s(_vm.$lang.labels.default) + ">\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.options.length > 1) ? _c('span', {
        staticClass: "arrow_to_move"
      }, [_c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemUp('options', index)
          }
        }
      }, [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemDown('options', index)
          }
        }
      }, [_vm._v("keyboard_arrow_down")])]) : _vm._e()]) : _vm._e()
    }), 0)] : _vm._e()
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.allergens))]), _vm._v(" "), (_vm.selectedAllergens.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": _vm.editAllergensToggle
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": _vm.editAllergensToggle
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.selectedAllergens.length > 0) ? _c('div', {
    staticClass: "views mt-2 p-3"
  }, [_vm._l((_vm.allergens), function(allergen, index) {
    return (_vm.selectedAllergens.indexOf(allergen.allergenId !== -1) && _vm.selectedAllergens[_vm.selectedAllergens.indexOf(allergen.allergenId)] === allergen.allergenId) ? [_c('p', {
      key: index
    }, [_vm._v(_vm._s(allergen.name[_vm.language]) + ", ")])] : _vm._e()
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.styles))]), _vm._v(" "), (_vm.styles.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Styles', 'styles')
      }
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Styles', 'styles')
      }
    }
  }, [_vm._v("edit")]), _vm._v(" "), (_vm.styles.length > 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.removeDefaults(_vm.styles)
      }
    }
  }, [_vm._v("\n                  turned_in_not\n                ")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.styles), function(style, index) {
    return (_vm.styles.length !== 0) ? [_c('ul', {
      key: index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (style.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v("\n                    " + _vm._s(style.name[lang.value]) + "\n                    "), (style.isDefault) ? _c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  <" + _vm._s(_vm.$lang.labels.default) + ">\n                ")]) : _vm._e(), _vm._v(" "), (_vm.styles.length > 1) ? _c('span', {
        staticClass: "arrow_to_move"
      }, [_c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemUp('styles', index)
          }
        }
      }, [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemDown('styles', index)
          }
        }
      }, [_vm._v("keyboard_arrow_down")])]) : _vm._e()]) : _vm._e()
    }), 0)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.inheritSelectedAttributes.styles), function(style, index) {
    return (_vm.inheritSelectedAttributes.styles !== 0) ? [_c('ul', {
      key: 'inhStyle-' + index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (style.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "color": "blue !important"
        }
      }, [_vm._v(_vm._s(style.name[lang.value]) + "\n                      " + _vm._s(style.price))])]) : _vm._e()
    }), 0)] : _vm._e()
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.variants))]), _vm._v(" "), (_vm.variants.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Variants', 'variants')
      }
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Variants', 'variants')
      }
    }
  }, [_vm._v("edit")]), _vm._v(" "), (_vm.variants.length > 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.removeDefaults(_vm.variants)
      }
    }
  }, [_vm._v("\n                  turned_in_not\n                ")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.variants), function(variant, index) {
    return (_vm.variants.length !== 0) ? [_c('ul', {
      key: index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (variant.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v("\n                    " + _vm._s(variant.name[lang.value]) + "\n                    " + _vm._s(variant.price) + "\n                    "), (variant.isDefault) ? _c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  <" + _vm._s(_vm.$lang.labels.default) + ">\n                ")]) : _vm._e(), _vm._v(" "), (_vm.variants.length > 1) ? _c('span', {
        staticClass: "arrow_to_move"
      }, [_c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemUp('variants', index)
          }
        }
      }, [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemDown('variants', index)
          }
        }
      }, [_vm._v("keyboard_arrow_down")])]) : _vm._e()]) : _vm._e()
    }), 0)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.inheritSelectedAttributes.variants), function(variant, index) {
    return (_vm.inheritSelectedAttributes.variants !== 0) ? [_c('ul', {
      key: 'inhStyle-' + index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (variant.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "color": "blue !important"
        }
      }, [_vm._v(_vm._s(variant.name[lang.value]) + "\n                      " + _vm._s(variant.price))])]) : _vm._e()
    }), 0)] : _vm._e()
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "checkbox-wrap",
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('h3', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.$lang.header.settings))]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.labelPrint,
      "hide-details": ""
    },
    model: {
      value: (_vm.labelPrint),
      callback: function($$v) {
        _vm.labelPrint = $$v
      },
      expression: "labelPrint"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.askDetails,
      "hide-details": ""
    },
    model: {
      value: (_vm.askDetails),
      callback: function($$v) {
        _vm.askDetails = $$v
      },
      expression: "askDetails"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.vatPrint,
      "hide-details": ""
    },
    model: {
      value: (_vm.vatPrint),
      callback: function($$v) {
        _vm.vatPrint = $$v
      },
      expression: "vatPrint"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.noDiscount,
      "hide-details": ""
    },
    model: {
      value: (_vm.noDiscount),
      callback: function($$v) {
        _vm.noDiscount = $$v
      },
      expression: "noDiscount"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.addsGalaxyCardBalance,
      "hide-details": ""
    },
    model: {
      value: (_vm.galaxyCardBalance),
      callback: function($$v) {
        _vm.galaxyCardBalance = $$v
      },
      expression: "galaxyCardBalance"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.color))]), _vm._v(" "), _c('v-layout', {
    staticClass: "mb-4",
    attrs: {
      "align-center": "",
      "row": ""
    }
  }, [(_vm.color) ? _c('span', {
    staticClass: "color-preview mr-3",
    style: ({
      'background-color': _vm.color
    })
  }) : _vm._e(), _vm._v(" "), _c('v-combobox', {
    staticClass: "min-w",
    attrs: {
      "label": _vm.$lang.header.color,
      "items": _vm.colors,
      "search-input": _vm.color,
      "hide-details": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.color = $event
      },
      "update:search-input": function($event) {
        _vm.color = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return _c('v-list-tile-content', {}, [_c('v-layout', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "row": "",
            "align-center": "",
            "justify-center": ""
          }
        }, [_c('div', {
          staticClass: "shrink mr-2"
        }, [_vm._v(_vm._s(data.item))]), _vm._v(" "), _c('v-flex', {
          staticClass: "list-color-preview",
          style: ({
            'background-color': data.item
          }),
          attrs: {
            "grow": ""
          }
        })], 1)], 1)
      }
    }], null, false, 2874364866),
    model: {
      value: (_vm.color),
      callback: function($$v) {
        _vm.color = $$v
      },
      expression: "color"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.taxCategory))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "row": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.taxCategories
    },
    nativeOn: {
      "input": function($event) {
        return (function (e) { return _vm.taxCategory = e.target.value; })($event)
      }
    },
    model: {
      value: (_vm.taxCategory),
      callback: function($$v) {
        _vm.taxCategory = $$v
      },
      expression: "taxCategory"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.courseNo))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "6",
      "rules": [function (v) { return v > 0 && v < 7 || 'Error'; }],
      "label": _vm.$lang.header.courseNo
    },
    model: {
      value: (_vm.courseNo),
      callback: function($$v) {
        _vm.courseNo = $$v
      },
      expression: "courseNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "fill-height": "",
      "align-start": "",
      "py-2": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.images))]), _vm._v(" "), _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openAddImage()
      }
    }
  }, [_vm._v("\n              add\n            ")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "height": "45%",
      "overflow-y": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.images.length > 0) ? _c('v-list', [_vm._l((_vm.filteredAddedImages), function(image, index) {
    return [_c('v-list-tile', {
      key: image.id,
      attrs: {
        "dense": "true"
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(image.label))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    }, [_vm._v(_vm._s(image.name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('div', {
      staticClass: "my-0 d-inline-block"
    }, [_c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.preview(image.base64Image)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.$lang.actions.preview) + "\n                        ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "dark": "",
        "icon": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImg(index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])], 1), _vm._v(" "), (index + 1 < _vm.items.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "height": "45%"
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.previewImage !== '') ? _c('v-img', {
    staticStyle: {
      "max-height": "200px !important"
    },
    attrs: {
      "src": _vm.previewImage,
      "contain": ""
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-start": "",
      "align-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "color": "blue",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.submitItem(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.copy))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "color": "blue",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.paste()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.paste))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-1 ml-5",
    attrs: {
      "color": "blue",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.plusOneFunct()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.importFromParent))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitItem()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.details) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.actions.edit) + " " + _vm._s(_vm.currentLabel))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeEdit()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.err))]) : _vm._e(), _vm._v(" "), (_vm.hasMultiple) ? _c('div', _vm._l((_vm.currentEdit), function(edit, index) {
    return _c('div', {
      key: index,
      staticClass: "single-item mb-3"
    }, [_c('div', {
      staticClass: "v-table__overflow"
    }, [_c('table', {
      staticClass: "v-datatable v-table theme--light"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "column text-xs-left",
      attrs: {
        "role": "columnheader",
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm.$lang.header.language))]), _vm._v(" "), _c('th', {
      staticClass: "column text-xs-left",
      attrs: {
        "role": "columnheader",
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm.$lang.header.name))]), _vm._v(" "), _c('th', {
      staticClass: "column text-xs-left",
      attrs: {
        "role": "columnheader",
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm.$lang.header.default))]), _vm._v(" "), _c('th', {
      staticClass: "column text-xs-left",
      attrs: {
        "role": "columnheader",
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm.$lang.header.actions))])])]), _vm._v(" "), _c('tbody', _vm._l((edit.names), function(item, index2) {
      return _c('tr', {
        key: index2
      }, [_c('td', [_vm._v(_vm._s(item.language))]), _vm._v(" "), _c('td', [_c('v-text-field', {
        attrs: {
          "type": "text",
          "value": item.name
        },
        on: {
          "blur": function($event) {
            item.name = item.name.trim()
          }
        },
        model: {
          value: (item.name),
          callback: function($$v) {
            _vm.$set(item, "name", $$v)
          },
          expression: "item.name"
        }
      })], 1), _vm._v(" "), _c('td', [(_vm.currentEdit[index].isDefault && _vm.currentLabel !== 'Options') ? _c('p', {
        staticClass: "default-item"
      }, [_vm._v(_vm._s(_vm.$lang.actions.yes))]) : _c('v-checkbox', {
        staticClass: "pt-3",
        attrs: {
          "color": "primary",
          "label": _vm.$lang.labels.isDefault
        },
        model: {
          value: (_vm.currentEdit[index].isDefault),
          callback: function($$v) {
            _vm.$set(_vm.currentEdit[index], "isDefault", $$v)
          },
          expression: "currentEdit[index].isDefault"
        }
      })], 1), _vm._v(" "), _c('td', [(!_vm.currentEdit[index].isDefault && _vm.currentLabel !== 'Options') ? _c('v-btn', {
        attrs: {
          "color": "primary",
          "fab": "",
          "small": ""
        },
        on: {
          "click": function($event) {
            return _vm.setEditToDefault(index, item)
          }
        }
      }, [_c('v-icon', [_vm._v("turned_in")])], 1) : _vm._e(), _vm._v(" "), (_vm.currentEdit[index].isDefault && _vm.currentLabel !== 'Options') ? _c('v-btn', {
        attrs: {
          "fab": "",
          "small": ""
        }
      }, [_c('v-icon', [_vm._v("turned_in_not")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
        attrs: {
          "fab": "",
          "small": "",
          "color": "error"
        },
        on: {
          "click": function($event) {
            return _vm.removeLang(index, index2)
          }
        }
      }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
    }), 0)])]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "justify-space-between": "",
        "align-center": ""
      }
    }, [(edit.languages.length > 0) ? _c('div', {
      staticClass: "text-xs-center"
    }, [_c('v-menu', [_c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "slot": "activator",
        "outline": "",
        "flat": "",
        "type": "button"
      },
      slot: "activator"
    }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.addlanguage) + "\n                  "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('v-list', _vm._l((edit.languages), function(lang, langIndex) {
      return _c('v-list-tile', {
        key: langIndex,
        staticClass: "dropdown-item",
        on: {
          "click": function($event) {
            return _vm.addEditLang(lang.value, langIndex, index)
          }
        }
      }, [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(lang.text) + "\n                    ")])], 1)
    }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.removeEdit(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$lang.actions.deleteitem) + "\n            ")])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [(_vm.hasPrice) ? _c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "type": "number",
        "label": "Price"
      },
      model: {
        value: (edit.price),
        callback: function($$v) {
          _vm.$set(edit, "price", $$v)
        },
        expression: "edit.price"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.currentLabel === 'Options') ? _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "max": _vm.quantityOfIncludedOptions,
        "rules": [function (value) { return value <= _vm.quantityOfIncludedOptions || 'Must not be higher than Quantity Of Included Options!'; }],
        "label": ((_vm.$lang.labels.includedQuantity) + " (max " + _vm.quantityOfIncludedOptions + ")")
      },
      model: {
        value: (edit.maxIncludedQuantity),
        callback: function($$v) {
          _vm.$set(edit, "maxIncludedQuantity", $$v)
        },
        expression: "edit.maxIncludedQuantity"
      }
    })], 1) : _vm._e()], 1)], 1)
  }), 0) : _c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "column text-xs-left",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.language))]), _vm._v(" "), _c('th', {
    staticClass: "column text-xs-left",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.name))]), _vm._v(" "), _c('th', {
    staticClass: "column text-xs-left",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.actions))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.currentEdit[0].names), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.language))]), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "text",
        "value": item.name
      },
      on: {
        "blur": function($event) {
          item.name = item.name.trim()
        }
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "color": "error",
        "fab": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeLang(0, index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [(_vm.hasMultiple) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "outline": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.addEdit()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (!_vm.hasMultiple && _vm.currentEdit[0].languages.length > 0) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-menu', [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "outline": "",
      "flat": "",
      "type": "button"
    },
    slot: "activator"
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.actions.addlanguage) + "\n              "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.currentEdit[0].languages), function(lang, index) {
    return _c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.addEditLang(lang.value, index)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(lang.text) + "\n                ")])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitEdit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.editViews) ? _c('div', {
    staticClass: "description"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.actions.editViews))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeViews()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, _vm._l((_vm.catalogViews), function(view, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": view.name[_vm.language]
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (view.selected),
        callback: function($$v) {
          _vm.$set(view, "selected", $$v)
        },
        expression: "view.selected"
      }
    })
  }), 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitViews()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.editAllergens) ? _c('div', {
    staticClass: "description"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.actions.editAllergens))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeAllergens()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_vm._l((_vm.catalogAllergens), function(allergen, index) {
    return [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": allergen.name[_vm.language]
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (allergen.selected),
        callback: function($$v) {
          _vm.$set(allergen, "selected", $$v)
        },
        expression: "allergen.selected"
      }
    })], 1)]
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitAllergens()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.editPrinter) ? _c('div', {
    staticClass: "description"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.actions.editPrinterCategories))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "small": "",
      "fab": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closePrinter()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.catalogPrinters), function(printerCategory, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "disabled": index === 0,
        "label": printerCategory.name
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (printerCategory.selected),
        callback: function($$v) {
          _vm.$set(printerCategory, "selected", $$v)
        },
        expression: "printerCategory.selected"
      }
    })
  }), 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitPrinters()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.addImage) ? _c('div', {
    staticClass: "description"
  }, [(_vm.errImage) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.errImage))]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.actions.addImage1))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.addImage = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.labels,
      "label": _vm.$lang.labels.choseLabelToAddImage
    },
    on: {
      "input": function($event) {
        _vm.selectedImage = {}
      }
    },
    model: {
      value: (_vm.selectedLabel),
      callback: function($$v) {
        _vm.selectedLabel = $$v
      },
      expression: "selectedLabel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "loading": _vm.loading,
      "label": _vm.selectedLabel === '' ? _vm.$lang.labels.selectLabelFirst : _vm.$lang.labels.selectImage,
      "items": _vm.filteredImages,
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.fetchImageById()
      }
    },
    model: {
      value: (_vm.selectedImageId),
      callback: function($$v) {
        _vm.selectedImageId = $$v
      },
      expression: "selectedImageId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [(_vm.loadingPreview) ? _c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedImage.base64Image) ? _c('v-img', {
    staticStyle: {
      "max-height": "180px  !important"
    },
    attrs: {
      "src": _vm.selectedImage.base64Image,
      "contain": ""
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "disabled": !_vm.selectedImage.base64Image,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitAddImage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit) + "\n        ")])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.901fdb30fe4fe8a3b45d.js